import { useEffect, useState } from "react";
import { findCrest, getCrestMap } from "@/lib/crest";

const TeamSide = ({ name, align = "left", win, crests }) => {
  const url = findCrest(crests, name);
  return (
    <div className={`flex flex-1 items-center gap-3 ${align === "right" ? "flex-row-reverse text-right" : ""}`}>
      {url ? (
        <img
          src={url}
          alt={`Escudo de ${name}`}
          className="h-11 w-11 shrink-0 object-contain"
          data-testid={`scoreboard-crest-${name?.toLowerCase().replace(/\s+/g, "-")}`}
        />
      ) : (
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg font-display text-lg font-extrabold ${
            win ? "bg-crimson text-white" : "bg-white/10 text-white/80"
          }`}
        >
          {name?.charAt(0)}
        </div>
      )}
      <div className={`min-w-0 ${align === "right" ? "items-end" : ""}`}>
        <p className="truncate font-display text-lg font-bold uppercase leading-tight text-white sm:text-xl">
          {name}
        </p>
      </div>
    </div>
  );
};

export const Scoreboard = ({ match, size = "md" }) => {
  const { home_team, away_team, home_score, away_score, competition, match_date } = match;
  const homeWin = home_score > away_score;
  const awayWin = away_score > home_score;
  const [crests, setCrests] = useState({});

  useEffect(() => {
    getCrestMap().then(setCrests);
  }, []);

  return (
    <div
      data-testid={`scoreboard-${match.slug || "cronica"}`}
      className="relative overflow-hidden rounded-2xl border border-edge bg-ink2"
    >
      <div className="stripes-rojiblancas h-1 w-full opacity-80" />
      <div className="p-5 sm:p-7">
        {(competition || match_date) && (
          <div className="mb-5 flex flex-wrap items-center gap-3">
            {competition && (
              <span className="font-mono-score text-[10px] font-semibold uppercase tracking-[0.25em] text-glow">
                {competition}
              </span>
            )}
            {match_date && (
              <span className="font-mono-score text-[10px] uppercase tracking-widest text-slate-500">
                {match_date}
              </span>
            )}
          </div>
        )}
        <div className="flex items-center gap-3 sm:gap-5">
          <TeamSide name={home_team} win={homeWin} crests={crests} />
          <div className="flex shrink-0 flex-col items-center">
            <div
              className={`flex items-center gap-2 rounded-xl bg-ink px-4 py-2 font-mono-score font-bold text-white ${
                size === "lg" ? "text-4xl sm:text-5xl" : "text-2xl sm:text-3xl"
              }`}
            >
              <span className={homeWin ? "text-glow" : ""}>{home_score}</span>
              <span className="text-crimson">:</span>
              <span className={awayWin ? "text-glow" : ""}>{away_score}</span>
            </div>
          </div>
          <TeamSide name={away_team} align="right" win={awayWin} crests={crests} />
        </div>
        {match.scorers?.length > 0 && size === "lg" && (
          <div className="mt-6 flex flex-col gap-1.5 border-t border-edge pt-5">
            {match.scorers.map((s, i) => (
              <p key={i} className="font-mono-score text-xs text-slate-400">
                <span className="mr-2 inline-block h-1.5 w-1.5 rounded-full bg-crimson align-middle" />
                {s}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Scoreboard;
